import { i18nNsFactory } from '@atlas-frontend/i18n';
import { FC, memo } from 'react';
import translations from './VersionCell.translations.json';
import { Flex, Tag } from 'antd';
import styled from 'styled-components';
import {
  colorDraftBg,
  colorDraftBorder,
  colorSuccessBg,
  colorSuccessBorder,
} from '@atlas-frontend/design-tokens';
import { DataVersionStatus } from '@atlas-frontend/sdk';

const { addTranslations, t } = i18nNsFactory('output-data-version');
addTranslations(translations);

export const VersionCell: FC<{
  versionStatus: DataVersionStatus | 'MIXED' | null;
  version?: string | null;
  versionNumber?: number | null;
  minorNumber?: number | null;
}> = memo((props) => {
  const { version, versionNumber, minorNumber, versionStatus } = props;
  const versionLabel = version
    ? version
    : versionNumber
      ? `${versionNumber}${minorNumber ? `.${minorNumber}` : ''}`
      : undefined;

  if (!versionStatus) {
    return null;
  }

  if (versionStatus === 'MIXED') {
    return t('MIXED');
  }

  return (
    <StyledTag $isDraft={versionStatus === 'DRAFT'}>
      <Flex gap="small" align="center">
        {versionLabel && <VersionSpan>{versionLabel}</VersionSpan>}
        <DataVersionStatus status={versionStatus} />
      </Flex>
    </StyledTag>
  );
});

const StyledTag = styled(Tag)<{ $isDraft: boolean }>`
  margin: 0;
  border-color: ${({ $isDraft }) =>
    $isDraft ? colorDraftBorder : colorSuccessBorder};
  background-color: ${({ $isDraft }) =>
    $isDraft ? colorDraftBg : colorSuccessBg};
`;

export const VersionSpan = styled.span`
  background-color: black;
  color: white;
  border-radius: 4px;
  padding: 0 3px;
  line-height: 14px;
`;
